import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle, XCircle, Clock } from "@phosphor-icons/react";
import { Brand } from "@/pages/Login";
import { api } from "@/lib/api";

const VIEW = {
  paid: [CheckCircle, "text-teal-600", "Ödemeniz alındı", "Teşekkür ederiz. Ödemeniz faturanıza tahsilat olarak işlendi."],
  pending: [Clock, "text-orange-400", "Ödeme kontrol ediliyor…", "Lütfen bu sayfayı kapatmayın."],
  failed: [XCircle, "text-red-600", "Ödeme tamamlanamadı", "Ödeme onaylanmadı. Size gönderilen bağlantıyla tekrar deneyebilirsiniz."],
  cancelled: [XCircle, "text-zinc-500", "Ödeme iptal edildi", "Ödeme yapılmadı. Dilediğiniz zaman aynı bağlantıyla tekrar deneyebilirsiniz."],
};

export default function PaymentResult({ cancelled = false }) {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState(cancelled || !sid ? "cancelled" : "pending");

  useEffect(() => {
    if (cancelled || !sid) return undefined;
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/pay/status/${sid}`);
        if (data.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(data.payment_status)) return setState("failed");
      } catch {
        return setState("failed");
      }
      tries += 1;
      if (tries < 15) timer = setTimeout(poll, 2000);
      else setState("failed");
      return undefined;
    };
    poll();
    return () => clearTimeout(timer);
  }, [cancelled, sid]);

  const [Icon, tone, title, text] = VIEW[state];
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-zinc-950 p-6 text-white grain">
      <Brand className="mb-8 text-3xl" />
      <div className="w-full max-w-md bg-white p-8 text-center text-zinc-900" data-testid="payment-result">
        <Icon size={56} weight="fill" className={`mx-auto ${tone}`} />
        <h1 className="mt-4 font-display text-2xl font-bold" data-testid="payment-result-title">{title}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{text}</p>
        <div className="mt-6 h-1 w-full bg-gradient-to-r from-[#2dd4bf] via-[#7dd3fc] to-[#fdba74]" />
      </div>
    </div>
  );
}
